$(document).on('turbolinks:load', function() {
  $(document).on('click', '.wiki .info-table a', function(e) {
    e.preventDefault();
    window.open(e.target.href, '_blank')
  })
});
